import { render, staticRenderFns } from "./BoardLayoutInformation.vue?vue&type=template&id=d1c83072&scoped=true&"
import script from "./BoardLayoutInformation.vue?vue&type=script&lang=js&"
export * from "./BoardLayoutInformation.vue?vue&type=script&lang=js&"
import style0 from "./BoardLayoutInformation.vue?vue&type=style&index=0&id=d1c83072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c83072",
  null
  
)

export default component.exports